import axios from "axios";

const instance = axios.create({
  baseURL: "https://api-football-v1.p.rapidapi.com/v2",
  headers: {
    "X-RapidAPI-Key": "43a40f01cfmsh176a9d4bd6d457fp1a6948jsnbbd3721bb9c9"
  }
});

instance.interceptors.request.use(config => {
  return config;
}, error => {
  return Promise.reject(error);
});

instance.interceptors.response.use(response => {
  return response;
}, error => {
  return Promise.reject(error);
});

export default instance;
